<template>
  <div>
    <!-- <b-overlay :show="LoaderStatus" rounded="sm"> -->
    <div class="addeval-content-container">
      <!-- Edit Name -->
      <b-row
        ><b-col>
          <div class="topDiv">
            <label class="label-txt-form"
              >Name<span class="asterik">*</span></label
            >
            <b-form-input
              class="filter-input"
              id="input-1"
              type="text"
              v-model.trim="$v.panel.name.$model"
              placeholder="Enter name"
              :class="{ error: $v.panel.name.$error }"
              @keyup.enter="updatePanel"
            >
            </b-form-input>
            <!-- Validations for Name -->
            <div
              v-if="$v.panel.name.$dirty && !$v.panel.name.required"
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-if="!$v.panel.name.alpha && $v.panel.name.required"
              class="errortxt position-absolute"
            >
              Please Enter a Valid Name
            </div>
            <div
              v-if="!$v.panel.name.maxLength && $v.panel.name.required"
              class="errortxt position-absolute"
            >
              Should not exceed 128 characters
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Edit Mail -->
      <b-row
        ><b-col>
          <div class="topDiv mt-3">
            <label class="label-txt-form"
              >Email ID<span class="asterik">*</span></label
            >
            <b-form-input
              class="disable-inputField filter-input"
              id="input-1"
              type="text"
              placeholder="Enter email"
              v-model.trim="$v.panel.email.$model"
              :class="{ error: $v.panel.email.$error }"
              disabled
            >
            </b-form-input>
            <!-- Validations for Mail -->
            <div
              v-if="$v.panel.email.$dirty && !$v.panel.email.required"
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-if="!$v.panel.email.maxLength"
              class="errortxt position-absolute"
            >
              Should not exceed 64 characters
            </div>
            <div
              v-if="!$v.panel.email.alpha"
              class="errortxt position-absolute"
            >
              Email is invalid
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Edit Contact Number -->
      <b-row
        ><b-col>
          <div class="topDiv mt-3">
            <label class="label-txt-form"
              >Contact Number<span class="asterik">*</span></label
            >
            <b-form-input
              class="filter-input"
              id="input-1"
              type="text"
              placeholder="Enter contact number"
              @keypress="NumbersOnly"
              v-model.trim="$v.panel.phoneNumber.$model"
              :class="{ error: $v.panel.phoneNumber.$error }"
              maxlength="10"
            >
            </b-form-input>
            <!-- Validations for Contact Number -->
            <div
              v-if="
                $v.panel.phoneNumber.$dirty && !$v.panel.phoneNumber.required
              "
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-if="
                !phoneValid ||
                ($v.panel.phoneNumber.required && !$v.panel.phoneNumber.alpha)
              "
              class="errortxt position-absolute"
            >
              Enter valid number
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Edit Area of Expertise Tags -->
      <b-row
        ><b-col>
          <div
            class="topDiv mt-3 aoeskl-field panellist-tags"
            ref="exp1"
            @click="expertisefunction()"
            v-closable="{
              exclude: ['exp1', 'expdropdown1'],
              handler: 'hideexpertiseoptions',
            }"
          >
            <label class="label-txt-form"
              >Area Of Expertise<span class="asterik">*</span></label
            >
            <b-form-tags
              remove-on-delete
              @input="expertisefunction()"
              class="text-truncate filter-input-pan w-100"
              :class="{
                'error reqd_add_1': $v.aoeoptiontags.$error,
                reqd_add_2: !$v.aoeoptiontags.$error,
                tagsinputField:
                  $v.aoeoptiontags.length > 0 && !$v.aoeoptiontags.$error,
              }"
              placeholder="Enter area of expertise"
              :tag-validator="tagValidatoraoe"
              invalid-tag-text="Duplicate tag(s)"
              v-model="$v.aoeoptiontags.$model"
            ></b-form-tags>
            <div>
              <span class="hint-txt"
                >Press "Enter" to add area of expertise</span
              >
            </div>

            <!-- Validations for Area of Expertise -->
            <div
              v-if="$v.aoeoptiontags.$dirty && !$v.aoeoptiontags.required"
              class="errortxt position-absolute mt-3"
            >
              Required
            </div>
          </div>
          <!-- Dropdown for Area of Expertise Tags-->
          <div
            v-if="aoe == true"
            class="qb-filter-modal-sug"
            ref="expdropdown1"
          >
            <div class="relativeclass aoeinput opt-check">
              <div class="aoesearchicon-pos">
                <img
                  src="../../assets/img/accesscontrol/inputsearch.svg"
                  alt=""
                />
              </div>
              <b-form-input
                class="inputField options"
                type="search"
                placeholder="Search"
                v-model.trim="searchexp"
                debounce="500"
                @update="searchExp"
              >
              </b-form-input>
              <b-overlay :show="spinnerStatus" rounded="sm">
                <b-form-group
                  class="qb-dd-group-sug min-height-adjustment-sugg"
                  v-if="searchexpres.length > 0"
                >
                  <b-form-checkbox
                    class="options pointer"
                    size="sm"
                    v-for="option in searchexpres"
                    :key="option.expertise"
                    :value="option.expertise.toLowerCase()"
                    v-model="aoeoptiontags"
                    name="flavour-4a"
                    :class="{
                      selectedTag: isSelectedaoe(option.expertise),
                      ' qb-dropdown-option-sugg': !isSelectedaoe(
                        option.expertise
                      ),
                    }"
                  >
                    {{ option.expertise }}
                  </b-form-checkbox>
                </b-form-group>
                <div
                  v-else-if="
                    searchexpres.length == 0 &&
                    searchexp.length > 0 &&
                    searchexp !== ''
                  "
                  class="mt-2 add-panel-name text-center p-3"
                  size="sm"
                >
                  No matching results for&nbsp;<span class="font-weight-bold"
                    >"{{ searchexp }}"</span
                  >.
                </div>
              </b-overlay>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Edit Skill Tags -->
      <b-row
        ><b-col>
          <div
            class="topDiv skl-mrgn aoeskl-field panellist-tags"
            ref="skl1"
            @click="skillfunction()"
            v-closable="{
              exclude: ['skl1', 'skldropdown1'],
              handler: 'hideskillOptions',
            }"
          >
            <label class="label-txt-form"
              >Skills<span class="asterik">*</span></label
            >
            <b-form-tags
              remove-on-delete
              class="text-truncate filter-input-pan w-100"
              @input="skillfunction()"
              :tag-validator="tagValidatorskill"
              invalid-tag-text="Duplicate tag(s)"
              placeholder="Enter skills"
              :class="{
                'error reqd_add_1': $v.skilloptionstag.$error,
                reqd_add_2: !$v.skilloptionstag.$error,
                tagsinputField:
                  $v.skilloptionstag.length > 0 && !$v.skilloptionstag.$error,
              }"
              v-model="$v.skilloptionstag.$model"
            ></b-form-tags>
            <div>
              <span class="hint-txt">Press "Enter" to add skills</span>
            </div>

            <!-- Validations for Skills -->
            <div
              v-if="$v.skilloptionstag.$dirty && !$v.skilloptionstag.required"
              class="errortxt position-absolute mt-3"
            >
              Required
            </div>
          </div>
          <!-- Dropdown for Skill Tags-->
          <div
            v-if="skilltag == true"
            class="qb-filter-modal-sug"
            ref="skldropdown1"
          >
            <div class="relativeclass aoeinput opt-check">
              <div class="aoesearchicon-pos">
                <img
                  src="../../assets/img/accesscontrol/inputsearch.svg"
                  alt=""
                />
              </div>
              <b-form-input
                class="inputField options"
                type="search"
                placeholder="Search"
                v-model.trim="searchskl"
                debounce="500"
                @update="searchSkl"
              >
              </b-form-input>
              <b-overlay :show="spinnerStatus" rounded="sm">
                <b-form-group
                  class="qb-dd-group-sug min-height-adjustment-sugg"
                  v-if="searchsklres.length > 0"
                >
                  <b-form-checkbox
                    class="pointer options"
                    size="sm"
                    v-for="option in searchsklres"
                    :key="option.skill"
                    name="flavour-4a"
                    :value="option.skill.toLowerCase()"
                    v-model="skilloptionstag"
                    :class="{
                      selectedTag: isSelectedskl(option.skill),
                      ' qb-dropdown-option-sugg': !isSelectedskl(option.skill),
                    }"
                  >
                    {{ option.skill }}
                  </b-form-checkbox>
                </b-form-group>
                <div
                  v-else-if="
                    searchsklres.length == 0 &&
                    searchskl.length > 0 &&
                    searchskl !== ''
                  "
                  class="mt-2 add-panel-name text-center p-3"
                  size="sm"
                >
                  No matching results for&nbsp;<span class="font-weight-bold"
                    >"{{ searchskl }}"</span
                  >.
                </div>
              </b-overlay>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Edit Evaluator and Cancel Button -->
    <div class="border-top pt-3 pr-3">
      <div class="d-flex align-items-center justify-content-end">
        <div class="mr-3 cancelpan-btn pointer">
          <b-button style="width: 87px" @click="$emit('cancelPan')"
            >Cancel</b-button
          >
        </div>
        <div class="addpanel pointer">
          <b-button class="pl-3 pr-3" @click="updatePanel"> Update </b-button>
        </div>
      </div>
    </div>
  </div>
  <!-- </b-overlay> -->
</template>

<script>
import toast from "../../components/mixin/toast";
import { getValidations } from "../../controllers/Panelist/validations";
import {
  searchExp,
  searchSkl,
  getPanelist,
  addUpdatePanel,
} from "../../controllers/Panelist/asynchronous";
import {
  hideexpertiseoptions,
  hideskillOptions,
  tagValidatoraoe,
  tagValidatorskill,
  expertisefunction,
  skillfunction,
} from "../../controllers/Panelist/helpers";
import { NumbersOnly } from "../../controllers/Candidate/helpers";

export default {
  name: "EditPanel",
  props: { panelistdata: {} },
  data() {
    return {
      // STRING
      searchexp: "",
      searchskl: "",
      skillsearch: "",
      expertisesearch: "",
      tag: "",

      // ARRAY
      searchexpres: [],
      searchsklres: [],
      aoeoptiontags: [],
      skilloptionstag: [],

      // BOOLEAN
      aoe: false,
      LoaderStatus: false,
      spinnerStatus: false,
      skilltag: false,
      phoneValid: true,

      // OBJECT
      panel: {
        panelID: "",
        skills: [],
        name: "",
        email: "",
        phoneNumber: "",
        areaOfExpertise: [],
      },
      aoetags: {
        expertise: [],
      },
      skillstags: {
        skill: [],
      },
    };
  },
  mixins: [toast],
  validations() {
    return getValidations(this);
  },
  created() {
    this.getPanel();
    this.searchSkl();
    this.searchExp();
  },
  methods: {
    isSelectedaoe(exp) {
      return this.aoeoptiontags.includes(exp);
    },
    isSelectedskl(skill) {
      return this.skilloptionstag.includes(skill);
    },
    searchExp() {
      searchExp(this);
    },
    searchSkl() {
      searchSkl(this);
    },
    getPanel() {
      getPanelist(this);
    },
    updatePanel() {
      addUpdatePanel(this, "fromEdit");
    },

    hideexpertiseoptions() {
      hideexpertiseoptions(this);
    },
    hideskillOptions() {
      hideskillOptions(this);
    },
    tagValidatoraoe(tag) {
      return tagValidatoraoe(this, tag);
    },
    tagValidatorskill(tag) {
      return tagValidatorskill(this, tag);
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    expertisefunction() {
      expertisefunction(this);
    },
    skillfunction() {
      skillfunction(this);
    },
  },
};
</script>

<style>
.b-form-tags.focus {
  box-shadow: none;
}

.close {
  opacity: unset;
}
.aoeinput .form-control {
  padding: 0.375rem 2.3rem !important;
}

.aoesearchicon-pos {
  position: absolute;
  top: 7px;
  left: 16px;
}

.edit-panel-twobtns {
  position: absolute;
  bottom: 10px;
  right: 25px;
}

.topDiv > .edit-panel-modaldisableinputField {
  font-size: 14px;
  font-weight: 400;
  color: #a4a0a0;
  background: #fdfdfd;
  background-color: #e9ecef;
  border: 0.7px solid #bbbbbb;
  padding: 5px 10px;
  border-radius: 3px !important;
}

.topDiv > .disable-inputField {
  font-family: "Montserrat";
  border: 1px solid #bbbbbb;
  border-radius: 8px !important;
  font-size: 14px;
  width: 100%;
  height: 36px;
  background: #d0d5dd;
  color: #000000;
  border-radius: 8px;
  box-shadow: inset 0px 1px 2px rgb(16, 24, 40, 0.05);
}

.topDiv > .disable-fieldsetStyle {
  color: var(--bg-tertiary);
  background: #f4f4f4;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  z-index: 4;
  padding-left: 6px;
  padding-right: 4px;
}
.fieldsetStyleactive {
  color: var(--bg-tertiary);
  background-color: white;
  font-weight: var(--weight-LM);
  font-size: var(--size-10);
  line-height: 18px;
}

.ac-inputField .text-muted {
  color: red !important;
}

.validationicon {
  position: absolute;
  top: 29px;
  right: 10px;
  background: var(--bg-white);
}
.aoeinput .form-control {
  background: #f1f1f1;
  border: none;
}
.reqd_add_2 .reqd_add_1 .b-form-tags-list .btn {
  display: none;
}

.panellist-tags .text-muted {
  color: red !important;
}
</style>
